var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleDownArrow = function SvgDoubleDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 18.344 6.346 12.69 7.4 11.637 12 16.22l4.6-4.584 1.054 1.053zm0-5.98L6.346 6.71 7.4 5.656 12 10.24l4.6-4.584 1.054 1.054z"
  })));
};
export default SvgDoubleDownArrow;